import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { addOrderThunk, addToCartThunk, addToWishlistThunk, fetchAddressesThunk, fetchCartItemsThunk, fetchProductByIdThunk, fetchWishlistThunk, removeFromWishlistThunk } from '../../thunks/thunks';

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    loading: false,
    error: null,
    cartList: [],
    wishlist: [],
    addresses:[],
    productDetails:{}
  },
  reducers: {
    addToCart: (state, action) => {
      state.cartList.push(action.payload);
      toast.success('Item added to cart!');
    },
    addToWishlist: (state, action) => {
      const existingItem = state.wishlist.find(item => item.id === action.payload.id);
      
      if (!existingItem) {
        state.wishlist.push(action.payload);
        toast.success('Item added to wishlist!');
      }
      else{
        toast.error('Item already in wishlist!');
      }
    },
    
    removeFromWishlist: (state, action) => {
      state.wishlist = state.wishlist.filter(
        (item) => item.id !== action.payload // Ensure you match by ID
      );
      toast.success('Item removed from wishlist!');
    },
    removeFromCartList: (state, action) => {
      state.cartList = state.cartList.filter(
        (item) => item.id !== action.payload.id // Ensure you match by ID
      );
      toast.success('Item removed from cart!');
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addToWishlistThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addToWishlistThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.wishlist = action.payload.wishlist;
        toast.success('Product added to wishlist successfully!');
      })
      .addCase(addToWishlistThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(action.payload.message);
      })
      .addCase(removeFromWishlistThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeFromWishlistThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.wishlist = state.wishlist.filter(
          (item) => item.productId !== action.meta.arg
        );
      })
      .addCase(removeFromWishlistThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(action.payload);
      })
      .addCase(addToCartThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addToCartThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.cartList = action.payload;
        toast.success('Product added to cart successfully!');
      })
      .addCase(addToCartThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(action.payload);
      })
      .addCase(fetchWishlistThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWishlistThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.wishlist = action.payload;
        console.log("Action payload for wishlist",action.payload)
      })
      .addCase(fetchWishlistThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCartItemsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCartItemsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.cartList = action.payload;
      })
      .addCase(fetchCartItemsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAddressesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAddressesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.addresses = action.payload; // Add this to your initial state
      })
      .addCase(fetchAddressesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchProductByIdThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      }
      )
      .addCase(fetchProductByIdThunk.fulfilled, (state, action) => {
        state.loading = false;
        console.log("action.payload",action.payload);
        const productData = action.payload;
        console.log("Product Data: ",productData);
        const productId = productData.id;
        state.productDetails[productId] = productData;
      })
      .addCase(addOrderThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      }
      )
      .addCase(addOrderThunk.fulfilled, (state) => {
        state.loading = false;
        state.cartList = [];
        toast.success('Order placed successfully!');
      })
  },
});

export const { addToCart, addToWishlist, removeFromWishlist, removeFromCartList, setIsLoggedIn } = cartSlice.actions;
export default cartSlice.reducer;
